import React, { useState, useEffect } from "react";
// import { Wallet } from "lucide-react";
// import { motion } from "framer-motion";
import { ArrowLeftRight } from "lucide-react";
import moment from "moment";

// import NewsFeed from "../assests/NewsFeed.svg";
// import QuickTransfer from "./QuickTransfer";

// import {
//   UseChartTistData,
//   UseLiveTradeData,
//   UseNewsFeedData,
//   UseDashboarddata,
//   UseEconomicCalenderData,
//   UseAssetsData,
// } from "../Utils/AllData";

// import ChartPlotting from "../Utils/chart";
// import LiveTrade from "./LiveTrade";
// import QuickDeposit from "./QuickDeposit";
import LoadingSpinner from "../components/loading-spinner";
import TradeHistory from "./TradeHistory";
import DashboardData from "./DashBoardData";
import QuickTransfer from "./QuickTransfer";
import LiveTrade from "./LiveTrade";
import { UseLiveTradeData, UseNewsFeedData } from "../Utils/AllData";

const style = {
  selectDiv:
    "flex items-center px-2 py-2  text-[14px] rounded-md mx-3 md-3 text-neutral-300  hover:bg-[#818CED]/10 hover:text-white/85  ease-linear duration-150 cursor-pointer",
  hideScrollbar: "overflow-y-auto scrollbar-hide"
};

// Add this CSS to your global stylesheet or in a CSS-in-JS solution
const globalStyles = `
  .scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  .scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
`;

// Inject the styles into the document head
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalStyles;
document.head.appendChild(styleSheet);

const HomePage = () => {
  const selectTransfer = "Withdrawal";
  const { data: liveTrade } = UseLiveTradeData();
  const { data: newsFeed } = UseNewsFeedData();
//   const [showSelectTransfer, setShowSelectTransfer] = useState(false);
  // const newsFeedData = []
  const newsFeedData = newsFeed && newsFeed.data.items;
  // const chartData = []
//   const dashboardData = []
//   const liveTradeData = []
//   const holdingData = []
//   const economicCalenderData = []
//   const { data: chartData } = UseChartTistData();
//   const { data: liveTrade } = UseLiveTradeData();
//   const { data: newsFeed } = UseNewsFeedData();
//   const { data: economicCalender } = UseEconomicCalenderData();
//   const { data: assetsData } = UseAssetsData();
//   const { data } = UseDashboarddata();

  // baclance
//   const dashboardData = data && data.data.values;

  // news feed Data
//   const newsFeedData = newsFeed && newsFeed.data.items;
  // economic calender
//   const economicCalenderData = economicCalender && economicCalender.data.items;

  //live trade data
//   const liveTradeData = liveTrade && liveTrade.data;
  //assets data
//   const holdingData = assetsData && assetsData.data;

//live trade data
const liveTradeData = liveTrade && liveTrade.data;

  //chart data
  // const plotChartData = chartData && chartData.data;
  // const performceAccountValue =
  //   plotChartData && plotChartData.map((item) => [item[0], item[1]]);
  // const performceAccountValueData =
  //   performceAccountValue &&
  //   performceAccountValue.map((innerArray, index) =>
  //     innerArray.map((value, columnIndex) => {
  //       // Skip the first column
  //       if (columnIndex === 0 || typeof value !== "string") {
  //         return value;
  //       }

  //       // Remove the leading rupee sign and commas, then convert to a number
  //       return parseFloat(value.replace(/^₹|,/g, ""));
  //     })
  //   );

  // const [isLoading, setIsLoading] = useState(true);
  // const [isLoadingCalender, setIsLaadingCalender] = useState(true);
  const [isLoadingNews, setIsLoadingNews] = useState(true);

  // useEffect(() => {
  //   // Set up a timer for fetching assetsData with a 5-second delay
  //   const timer = setTimeout(() => {
  //     setIsLoading(false); // Update loading state after the timeout
  //   }, 3000); // Adjust the timeout duration as needed

  //   // Cleanup function to clear the timer if the component unmounts or if data is fetched
  //   return () => clearTimeout(timer);
  // }, []);

  useEffect(() => {
    const newsTimer = setTimeout(() => {
      setIsLoadingNews(false);
    }, 3000);

    return () => clearTimeout(newsTimer);
  }, []);

  // useEffect(() => {
  //   const calenderTimer = setTimeout(() => {
  //     setIsLaadingCalender(false);
  //   }, 3000);
  //   // Cleanup function to clear the timer if the component unmounts or if data is fetched

  //   return () => clearTimeout(calenderTimer);
  // }, []);

  return (
    <div className="flex flex-col md:flex-row pt-16 md:pt-12 px-3 md:px-6 lg:px-12 w-full">
      <div className="relative w-full pt-10 pb-2 md:pt-12 md:pb-4 lg:pt-16 lg:pb-8">
        <div className="absolute -top-[450px] -left-[200px] z-0 blur-box w-[460px] h-[560px] md:w-[760px] md:h-[760px] rounded-full filter blur-2xl opacity-90"></div>

        <div className="flex flex-col md:flex-row h-full gap-4">
          <div className="w-full md:w-[30%] z-10">
            {/* Wallet Balance  */}
            <DashboardData />
            {/* Quick Transfer  */}
            <div className=" z-10 w-full mt-4  bg-gradient-to-tl from-[#FEF35A99]/90 via-[#FFFFFF]/20 to-[#FEF35A99]/10 p-[1px]  rounded-[12px] md:rounded-[26px] shadow-custom-inner backdrop-blur-custom bg-black">
              <div
                className={`flex flex-col justify-center h-full  text-white bg-gradient-to-b from-[#000000]/80 from-10% via-[#000000] via-80% to-[#000000] to-20%  rounded-[12px] md:rounded-[26px] shadow-custom-inner-high backdrop-blur-custom bg-black"`}
              >
                <div className="space-y-1 md:space-y-3 px-4 py-3 md:px-6 md:py-4 ">
                  <div className="text-[#FEF35A] text-lg flex flex-row items-center">
                    <ArrowLeftRight size={18} />{" "}
                    <span className="text-lg ml-3">Quick Withdrawal</span>
                  </div>
                  {/* <div className="relative">
                    <div
                      className="py-2 px-4 flex flex-row items-center justify-between border border-[#ffffff]/20 rounded-[8px]  cursor-pointer"
                      onClick={() => setShowSelectTransfer(!showSelectTransfer)}
                    >
                      <div className="capitalize text-lg text-white font-semibold font-poppins">
                        {" "}
                        {selectTransfer}
                      </div>
                      <div
                        className={`pl-2 ease-linear duration-150 text-white cursor-pointer`}
                      >
                        {showSelectTransfer ? (
                          <ChevronUpIcon className="w-5 h-5 text-white/50" />
                        ) : (
                          <ChevronDownIcon className="w-5 h-5 text-white/50" />
                        )}
                      </div>
                    </div>
                    {showSelectTransfer && (
                      <motion.div
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        transition={{ duration: 0.5, type: "spring" }}
                        exit={{ y: -50, opacity: 0 }}
                        className={`absolute right-0 top-12 bg-[#14141d] rounded-lg flex flex-col w-[100%] pt-2 pb-2 z-50 `}
                      >
                        <div
                          className={`${style.selectDiv} pl-3 font-medium`}
                          onClick={() => {
                            setSelectTransfer("Withdrawal");
                            setShowSelectTransfer(!showSelectTransfer);
                          }}
                        >
                          Withdrawal
                        </div>
                        <div
                          className={`${style.selectDiv} pl-3 font-medium`}
                          onClick={() => {
                            setSelectTransfer("Deposit");
                            setShowSelectTransfer(!showSelectTransfer);
                          }}
                        >
                          Deposit
                        </div>
                      </motion.div>
                    )}
                  </div> */}
                </div>

                <div className="bg-[#000000]/10 pt-4 rounded-b-[12px] md:rounded-b-[26px] space-y-1 md:space-y-3 px-4 py-3 md:px-6 md:py-4">
                    <QuickTransfer selectTransfer={selectTransfer} />
                </div>
              </div>
            </div>
          </div>

          {/* Account Chart  */}

          <div className="z-10 w-full md:w-[50%]">

            {/* <div className="bg-gradient-to-b from-[#FEF35A99]/90 via-[#FFFFFF]/20 to-[#FEF35A99]/10 p-[1.5px]  rounded-[12px] md:rounded-[26px] rounded-lg shadow-custom-inner backdrop-blur-custom bg-black">
              <div
                className={`flex flex-col px-2 py-3 md:px-2 md:py-4 bg-gradient-to-b from-[#000000]/80 from-80% via-[#000000] via-80% to-[#000000] to-20%   rounded-[12px] md:rounded-[26px]  p-4 text-white `}
              >
                <div
                  className={`md:px-8 leading-5 text-[9px] text-[#ffffff]/50 font-normal md:text-base lg:text-xl`}
                >
                  Equity Curve
                </div> */}
                <LiveTrade tradeData={liveTradeData && liveTradeData} />

                {/* <ChartPlotting
                  chartData={
                    performceAccountValueData && performceAccountValueData
                  }
                  titleOne="Account"
                /> */}
              {/* </div>
            </div> */}
            <div className="bg-gradient-to-tl from-[#FEF35A99]/90 via-[#FFFFFF]/20 to-[#FEF35A99]/10 p-[1px]  rounded-[12px] md:rounded-[26px] rounded-lg shadow-custom-inner backdrop-blur-custom bg-black">
              <div
                className={`flex flex-col px-2 py-3 md:px-2 md:py-4 bg-gradient-to-b from-[#000000]/80 from-80% via-[#000000] via-80% to-[#000000] to-20%   rounded-[12px] md:rounded-[26px]  p-4 text-white shadow-custom-inner-high backdrop-blur-custom bg-black" `}
              >
                {/* <div
                  className={`md:px-8 leading-5 text-[9px] text-[#ffffff]/50 font-normal md:text-base lg:text-xl`}
                >
                  Equity Curve
                </div> */}
                <TradeHistory />

                {/* <ChartPlotting
                  chartData={
                    performceAccountValueData && performceAccountValueData
                  }
                  titleOne="Account"
                /> */}
              </div>
            </div>
          </div>

          <div className="w-full md:w-[30%]">
            {/* Holdings  */}
            {/* {!holdingData && !holdingData ? (
              <div className="w-full bg-gradient-to-b from-[#818CEE]/90  via-[#FFFFFF]/20 to-[#818CE6]/10 p-[1.5px]  rounded-[12px] md:rounded-[26px]">
                <div
                  className={`flex flex-col justify-center space-y-1 md:space-y-3 px-4 py-3 h-full md:px-10 md:py-4 bg-gradient-to-b from-[#000000]/80 from-10% via-[#29293e] via-80% to-[#29293e] to-20%   rounded-[12px] md:rounded-[26px]  p-4 text-white`}
                >
                  <div
                    className={`leading-5 text-[9px] text-[#ffffff] font-normal md:text-base lg:text-lg`}
                  >
                    Assets
                  </div>
                  <div className="flex flex-row">
                    <div className="w-[33%] text-xs text-[#ffffff]/50 font-light font-poppins">
                      Symbol
                    </div>
                    <div className="w-[33%] text-right text-xs text-[#ffffff]/50 font-light font-poppins">
                      Last
                    </div>
                    <div className="w-[33%] text-right text-xs text-[#ffffff]/50 font-light font-poppins">
                      Chg%
                    </div>
                  </div>
                  <div className="py-4 flex flex-row justify-center text-white text-xl md:text-2xl">
                    {isLoading === true ? (
                      <LoadingSpinner />
                    ) : (
                      "No Data Available"
                    )}
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full bg-gradient-to-b from-[#818CEE]/90  via-[#FFFFFF]/20 to-[#818CE6]/10 p-[1.5px]  rounded-[12px] md:rounded-[26px]">
                <div
                  className={`flex flex-col justify-center space-y-1 md:space-y-3 px-4 py-3 h-full md:px-10 md:py-4 bg-gradient-to-b from-[#000000]/80 from-10% via-[#29293e] via-80% to-[#29293e] to-20%   rounded-[12px] md:rounded-[26px]  p-4 text-white`}
                >
                  <div
                    className={`leading-5 text-[9px] text-[#ffffff] font-normal md:text-base lg:text-lg`}
                  >
                    Assets
                  </div>
                  <div className="flex flex-row">
                    <div className="w-[33%] text-xs text-[#ffffff]/50 font-light font-poppins">
                      Symbol
                    </div>
                    <div className="w-[33%] text-right text-xs text-[#ffffff]/50 font-light font-poppins">
                      Last
                    </div>
                    <div className="w-[33%] text-right text-xs text-[#ffffff]/50 font-light font-poppins">
                      Chg%
                    </div>
                  </div>
                  {holdingData &&
                    holdingData.map((ele, i) => {
                      return (
                        <div
                          className={
                            i === holdingData.length - 1
                              ? "flex flex-row pb-2 items-center"
                              : "flex flex-row border-b border-[#ffffff]/10 pb-2 items-center"
                          }
                          key={i}
                        >
                          <div className="w-[33%] flex flex-row items-center text-sm text-[#ffffff] font-light font-poppins">
                            <img src={ele[3]} alt="USD" className="pr-1" />
                            {ele[0]}
                          </div>
                          <div className="w-[33%] text-right text-sm text-[#ffffff] font-light font-poppins">
                            {parseFloat(ele[1]).toFixed(2)}
                          </div>
                          <div
                            className={
                              parseFloat(ele[2]) > 0
                                ? "w-[33%] text-right text-sm text-[#3AC985] font-semibold font-poppins"
                                : parseFloat(ele[2]) === 0
                                ? "w-[33%] text-right text-sm text-[#ffffff] font-light font-poppins"
                                : "w-[33%] text-right text-sm text-[#A93333] font-semibold font-poppins"
                            }
                          >
                            {ele[2]}%
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )} */}

            {/* News data  */}
            <div className="w-full bg-gradient-to-tl from-[#FEF35A99]/90 via-[#FFFFFF]/20 to-[#FEF35A99]/10 p-[1px]  rounded-[12px] md:rounded-[26px] mb-4">
              <div
                className={`max-h-[90vh] px-6 md:pl-8  bg-gradient-to-b from-[#000000]/80 from-10% via-[#000000] via-80% to-[#000000] to-20%  rounded-[12px] md:rounded-[26px]  text-white shadow-custom-inner-high backdrop-blur-custom bg-black"`}
              >
                {!newsFeedData && !newsFeedData ? (
                  <div className="py-4">
                    <div className="text-white text-lg font-poppins">News</div>
                    <div className="py-4 flex flex-row justify-center text-white text-base md:text-lg">
                      {isLoadingNews === true ? (
                        <LoadingSpinner />
                      ) : (
                        "No News Available"
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col  bg-transparent max-h-[90vh] overflow-hidden py-4">
                    <div className="text-white text-lg font-poppins">News</div>
                    <div className={`flex flex-col py-4 flex-1 space-y-2 bg-transparent border-red-500 custom-scroll ${style.hideScrollbar}`}>
                      {newsFeedData &&
                        newsFeedData.map((ele, i) => {
                          return (
                            <a
                              className={
                                i === newsFeedData.length - 1
                                  ? "pb-2 items-center cursor-pointer"
                                  : "border-b border-[#ffffff]/10 pb-2 items-center cursor-pointer"
                              }
                              key={i}
                              href={ele.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <div className="flex items-center">
                                {/* <img src={NewsFeed} alt="NewsFeed" /> */}
                                <span className="ml-2 text-xs text-[#ffffff]/30 font-light font-poppins">
                                  {moment(ele.pubDate).fromNow()}
                                </span>
                                <span className="ml-2 text-xs text-[#ffffff]/30 font-light font-poppins">
                                  {ele.creator}
                                </span>
                              </div>
                              <div className="mt-2 text-sm text-[#ffffff]/80 font-normal font-poppins">
                                {ele.title}
                              </div>
                            </a>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* Economic Calender*/}
            {/* <div className="mt-6 w-full bg-gradient-to-b from-[#818CEE]/90  via-[#FFFFFF]/20 to-[#818CE6]/10 p-[1.5px]  rounded-[12px] md:rounded-[26px]">
              <div
                className={`h-[400px]  px-6 md:pl-8  bg-gradient-to-b from-[#000000]/80 from-10% via-[#29293e] via-80% to-[#29293e] to-20%  rounded-[12px] md:rounded-[26px]  text-white`}
              >
                {!economicCalenderData && !economicCalenderData ? (
                  <div className="py-4">
                    <div className="text-white text-lg font-poppins">
                      Economic Calendar
                    </div>
                    <div className="py-4 flex flex-row justify-center text-white text-base md:text-lg">
                      {isLoadingCalender === true ? (
                        <LoadingSpinner />
                      ) : (
                        "No Economic Calendar Available"
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col  bg-transparent  h-[400px] overflow-hidden py-4">
                    <div className="text-white text-lg font-poppins">
                      Economic Calendar
                    </div>
                    <div className="flex flex-col py-4 flex-1 space-y-2  bg-transparent  border-red-500  overflow-y-auto custom-scroll">
                      {economicCalenderData &&
                        economicCalenderData.map((ele, i) => {
                          return (
                            <a
                              className={
                                i === economicCalenderData.length - 1
                                  ? "pb-2 items-center cursor-pointer"
                                  : "border-b border-[#ffffff]/10 pb-2 items-center cursor-pointer"
                              }
                              key={i}
                              href={ele.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <div className="flex items-center">
                                <img src={NewsFeed} alt="NewsFeed" />
                                <span className="ml-2 text-xs text-[#ffffff]/30 font-light font-poppins">
                                  {moment(ele.pubDate).fromNow()}
                                </span>
                                <span className="ml-2 text-xs text-[#ffffff]/30 font-light font-poppins">
                                  {ele.creator}
                                </span>
                              </div>
                              <div className="mt-2 text-sm text-[#ffffff]/80 font-normal font-poppins">
                                {ele.title}
                              </div>
                            </a>
                          );
                        })}
                    </div>
                  </div>
                )}
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
